import * as React from 'react';

import type {User} from 'nutshell-core/users/users-types';

import type {Lead} from 'nutshell-graphql-types';

import {CoreEntitySidebar} from '../../core-entity/layout/core-entity-sidebar';
import {getWidgetComponents} from '../../core-entity/util/widget-components';

type Props = {
    lead: Lead;
    user: User;
    hasScrolledPastCheckpoint: boolean;
    hasFullHeightSidebar?: boolean;
};

export function Sidebar(props: Props) {
    const widgets = getWidgetComponents({
        mode: 'lead',
        lead: props.lead,
        user: props.user,
        widgets: props.lead.stagesetForWidgets.sidebarWidgets,
    });

    return (
        <CoreEntitySidebar
            hasScrolledPastCheckpoint={props.hasScrolledPastCheckpoint}
            hasFullHeightSidebar={props.hasFullHeightSidebar}
        >
            {widgets}
        </CoreEntitySidebar>
    );
}
